import Cookies from 'js-cookie';

export const getCookieDomainForHost = (hostname: string): string | undefined => {
  if (hostname === 'warroom-test.com.br' || hostname.endsWith('.warroom-test.com.br')) {
    return '.warroom-test.com.br';
  }
  if (hostname === 'stilingue.com.br' || hostname.endsWith('.stilingue.com.br')) {
    return '.stilingue.com.br';
  }
  return undefined;
};

export const getCookieDomainForLocation = (hostname: string, protocol: string): string | undefined => {
  return protocol === 'https:' ? getCookieDomainForHost(hostname) : undefined;
};

export const CONFIG = {
  GATEWAY: {
    STAGING: 'https://secure-backend-api-staging.stilingue.com.br/',
    PRODUCTION: 'https://secure-backend-api.stilingue.com.br/',
  },

  GATEWAY_SECURE: {
    STAGING: 'https://secure-backend-api-internal-staging.stilingue.com.br/',
    PRODUCTION: 'https://secure-backend-api-internal.stilingue.com.br/',
  },

  VERSION: {
    STAGING: 'staging',
    PRODUCTION: 'prod',
  },

  LOGIN_SERVICE: {
    DEVELOPMENT: 'http://localhost:3333/',
    STAGING: 'https://login.warroom-test.com.br/',
    PRODUCTION: 'https://login.stilingue.com.br/',
  },

  AUTH: {
    SSID: 'stilingue-session-id',
    USER_ID: 'usr_id',
    ACC_ID: 'acc_id',
    UNI_ID: 'uni_id',
    TIMEOUT: 30000,
  },

  isDevelopment: () => {
    if (typeof globalThis !== 'undefined') {
      return (
        globalThis.location.hostname === 'localhost' ||
        globalThis.location.hostname === '127.0.0.1' ||
        globalThis.location.hostname.includes('dev')
      );
    }
    return false;
  },

  isStaging: () => {
    if (typeof globalThis !== 'undefined') {
      return globalThis.location.hostname.includes('warroom-test');
    }
    return true;
  },

  getCookieDomain: () => {
    return getCookieDomainForLocation(globalThis.location.hostname, globalThis.location.protocol);
  },

  cookieOrParam(paramName: string): string | null | undefined {
    const cookieValue = Cookies.get(paramName);
    
    if (cookieValue) return cookieValue;
    
    return new URLSearchParams(globalThis.location.search).get(paramName);
  },

  getServiceUrl: (serviceName: string, customVersion?: string) => {
    return devOrStgIfNotThenProd(
      `${CONFIG.GATEWAY.STAGING}${serviceName}/${customVersion ?? CONFIG.VERSION.STAGING}`,
      `${CONFIG.GATEWAY.PRODUCTION}${serviceName}/${customVersion ?? CONFIG.VERSION.PRODUCTION}`,
    );
  },

  getLoginServiceUrl: () => {
    if (CONFIG.isDevelopment()) {
      return CONFIG.LOGIN_SERVICE.DEVELOPMENT;
    } else if (CONFIG.isStaging()) {
      return CONFIG.LOGIN_SERVICE.STAGING;
    }
    return CONFIG.LOGIN_SERVICE.PRODUCTION;
  },

  getGatewayUrl: () => {
    return devOrStgIfNotThenProd(CONFIG.GATEWAY.STAGING, CONFIG.GATEWAY.PRODUCTION);
  },

  getSecureGatewayUrl: () => {
    return devOrStgIfNotThenProd(CONFIG.GATEWAY_SECURE.STAGING, CONFIG.GATEWAY_SECURE.PRODUCTION);
  },

  getSecureStagingGatewayUrl: () => {
    return devOrStgIfNotThenProd(CONFIG.GATEWAY_SECURE.STAGING, CONFIG.GATEWAY.PRODUCTION);
  },

  getVersion: () => {
    return devOrStgIfNotThenProd(CONFIG.VERSION.STAGING, CONFIG.VERSION.PRODUCTION);
  },

  getChannelsUrl: () => {
    return devOrStgIfNotThenProd(
      `${CONFIG.GATEWAY.STAGING}channels/${CONFIG.VERSION.STAGING}/channels/`,
      `${CONFIG.GATEWAY.PRODUCTION}channels/${CONFIG.VERSION.PRODUCTION}/channels/`,
    );
  },

  THEMES_PASSKEY: {
    PRODUCTION: 'bGVzc2lzbW9yZWxlc3Npc21vcmVsZXNzaXNtb3Jl',
  },
};
export function devOrStg(): boolean {
  return CONFIG.isDevelopment() || CONFIG.isStaging();
}

function devOrStgIfNotThenProd(devStg: string, prod: string) {
  return devOrStg() ? devStg : prod;
}